// https://manchenkoff.gitbook.io/nuxt-auth-sanctum/advanced/error-handling#error-helper

import { AxiosError } from "axios";

const NOT_FOUND_ERROR_CODE = 404;
const VALIDATION_ERROR_CODE = 422;
const SERVER_ERROR_CODE = 500;

export const useApiError = (error: unknown) => {
  const isFetchError = error instanceof AxiosError;
  const isValidationError =
    isFetchError && error.response?.status === VALIDATION_ERROR_CODE;
  const isNotFoundError =
    isFetchError && error.response?.status === NOT_FOUND_ERROR_CODE;
  // The request never got a response, e.g. the visitor is offline or an
  // ad blocker or browser extension on the host page blocked it
  const isNetworkError = isFetchError && !error.response;

  const code = isFetchError ? error.response?.status : SERVER_ERROR_CODE;
  const bag: Record<string, string[]> = isValidationError
    ? error.response?.data.errors
    : {};

  return {
    isValidationError,
    isNotFoundError,
    isNetworkError,
    code,
    bag,
  };
};
